/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { ReactNode, useMemo } from 'react';

import { Alert, Box, CircularProgress } from '@mui/material';

import { ReportableApiError } from './ReportableApiError';

type Props = {
  queries: { isLoading: boolean; error: unknown }[];
  children: ReactNode;
};

export function QueryLoader(props: Props) {
  const error = useMemo(() => props.queries.find(query => query.error)?.error, [props.queries]);
  const isLoading = useMemo(() => props.queries.some(query => query.isLoading), [props.queries]);

  return error ? (
    <Alert severity="error">
      <ReportableApiError error={error as any} />
    </Alert>
  ) : isLoading ? (
    <Box style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <CircularProgress color="primary" />
    </Box>
  ) : (
    props.children
  );
}
